import {InitPage} from "../index";

class NavErrorTemplate {
    constructor() {
        this.init();
    }

    init() {

    }
}

export function LoadPage() {
    InitPage("error_templates index", () => {
        const c = new NavErrorTemplate();
    });
}
